@import './components/ads-dropdown-item/ads-dropdown-item.scss';
@import './components/ads-dropdown-group/ads-dropdown-group.scss';
@import './components/ads-dropdown-divider/ads-dropdown-divider.scss';

@import 'core';

@import '@fortawesome/fontawesome-pro/scss/fontawesome.scss';
@import '@fortawesome/fontawesome-pro/scss/brands.scss';
@import '@fortawesome/fontawesome-pro/scss/light.scss';
@import '@fortawesome/fontawesome-pro/scss/regular.scss';
@import '@fortawesome/fontawesome-pro/scss/solid.scss';

/**
 * @prop --ads-dropdown-background-color: Background color
 * @prop --ads-dropdown-background-color-focus: Focused background color
 * @prop --ads-dropdown-background-color-hover: Hovered background color
 *
 * @prop --ads-dropdown-border-color: Border color
 * @prop --ads-dropdown-caret-color: Caret Color
 * @prop --ads-dropdown-caret-margin-left: Caret margin left
 * @prop --ads-dropdown-caret-margin-right: Caret margin right
 *
 * @prop --ads-dropdown-color: Text color
 * @prop --ads-dropdown-icon-color: Icon color
 *
 * @prop --ads-dropdown-item-background-color: Item background color
 * @prop --ads-dropdown-item-label-margin-left: Item label margin left
 * @prop --ads-dropdown-item-label-margin-right: Item label margin right
 *
 * @prop --ads-dropdown-items-z-index: Z-index layer height
 */

$ads-dropdown-items-box-shadow: none;

:host {
  --ads-dropdown-items-box-shadow: #{$ads-dropdown-items-box-shadow};

  box-sizing: border-box;
  display: inline-block;
}

:host([theme='default']) {
  @include ads-vars-component-button;
  @include ads-vars-component-dropdown-default;
}

:host([theme='dark']) {
  @include ads-vars-component-button-dark;
  @include ads-vars-component-dropdown-dark;
}

:host * {
  box-sizing: inherit;
}

:host([theme='default']) {
  @include ads-vars-component-button;
  @include ads-vars-component-dropdown-default;
}

:host([theme='dark']) {
  @include ads-vars-component-button-dark;
  @include ads-vars-component-dropdown-dark;
}

:host([dir='ltr']) {
  @include ads-vars-component-dropdown-ltr;
}

:host([dir='rtl']) {
  @include ads-vars-component-dropdown-rtl;
}

.c-dropdown {
  font-size: 1rem;
  position: static;

  /***************/
  /* DESCENDANTS */
  /***************/

  &__selector {
    @include ads-button;
    @include ads-button-tertiary;
    align-items: center;
    display: flex;
    font-family: var(--ads-font-family);
    justify-content: space-between;
    letter-spacing: inherit;
    margin: 0;
    width: 100%;
    word-spacing: inherit;
    z-index: $layer-2;

    &.is-primary {
      @include ads-button-primary;
    }

    &.is-secondary {
      @include ads-button-secondary;
    }

    &.is-tertiary {
      @include ads-button-tertiary;
    }

    &.is-medium {
      @include ads-button-medium;
    }

    &.is-small {
      @include ads-button-small;
    }
  }

  &__icon {
    margin-right: 9px;
  }

  &__label + &__caret {
    margin-left: var(--ads-dropdown-caret-margin-left, $ads-dropdown-caret-margin-left-ltr);
    margin-right: var(--ads-dropdown-caret-margin-right, $ads-dropdown-caret-margin-right-ltr);
  }

  &__items {
    border-color: var(--ads-dropdown-border-color, $ads-dropdown-border-color);
    border-style: solid;
    border-width: 1px;
    color: var(--ads-dropdown-color, $ads-dropdown-color);
    display: inline-block;
    font-size: 1rem;
    max-height: 0;
    min-width: 100%;
    overflow: hidden;
    position: absolute;
  }

  /*************/
  /* MODIFIERS */
  /*************/

  &.is-small {
    .c-dropdown__group,
    .c-dropdown__items {
      font-size: 0.8rem;
    }

    .c-dropdown__group__item {
      padding: 0.25rem;
    }

    .c-dropdown__item {
      padding: 0.25rem 0.5rem;
    }

    .c-dropdown__group .c-dropdown__item {
      padding: 0.25rem 0.25rem 0.25rem 0.75rem;
    }
  }

  &.is-open {
    .c-dropdown__items {
      background-color: var(--ads-dropdown-background-color, $ads-dropdown-background-color);
      border-color: var(--ads-dropdown-border-color, $ads-dropdown-border-color);
      border-style: solid;
      border-width: 1px;
      border-radius: var(--ads-dropdown-border-radius, $ads-dropdown-border-radius);
      box-shadow: var(--ads-dropdown-items-box-shadow, $ads-dropdown-items-box-shadow);
      cursor: pointer;
      display: block;
      margin-top: 4px;
      max-height: 400px;
      overflow: auto;
      position: absolute;
      z-index: var(--ads-dropdown-items-z-index, $ads-dropdown-items-z-index);
    }
  }
}
